import React from "react";
import ResourcePage from "@/components/ResourcePage";
import { COUNTRIES } from "@/lib/api";

const SOURCES = ["Website", "Product page", "Direct enquiry", "Referral", "Trade show", "Email", "WhatsApp", "Other"];
const TYPES = ["Distributor", "Wholesaler", "Importer", "Pharmacy", "Hospital", "Retailer", "Manufacturer", "Other"];

export default function Buyers() {
  return (
    <ResourcePage
      title="Buyers & Customers" name="Buyer" endpoint="buyers"
      subtitle="International buyers, importers and distributors"
      emptyMessage="No buyers yet. Add international buyers to track their enquiries and orders."
      canExport
      columns={[
        { key: "company_name", label: "Company" },
        { key: "contact_person", label: "Contact" },
        { key: "country", label: "Country" },
        { key: "buyer_type", label: "Type" },
        { key: "lead_source", label: "Source" },
      ]}
      defaultValues={{ buyer_type: "Distributor", lead_source: "Website" }}
      formFields={[
        { name: "company_name", label: "Company name", required: true, full: true },
        { name: "contact_person", label: "Contact person" },
        { name: "email", label: "Email" },
        { name: "phone", label: "Phone" },
        { name: "country", label: "Country", type: "select", options: COUNTRIES },
        { name: "city", label: "City" },
        { name: "buyer_type", label: "Buyer type", type: "select", options: TYPES },
        { name: "lead_source", label: "Lead source", type: "select", options: SOURCES },
        { name: "website", label: "Website" },
        { name: "product_interests", label: "Product interests" },
        { name: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}
